// components/country-info/country-info.component.ts
import { Component, OnInit } from '@angular/core';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { CountryInfoService } from '../../services/country-info.service';


@Component({
  selector: 'app-country-info',
  templateUrl: './country-info.component.html',
  styleUrls: ['./country-info.component.scss'],
})
export class CountryInfoComponent implements OnInit {
  flagPath = '';
  gmtLabel = '';

  constructor(
    private currency: CurrencyService,
    private countryInfo: CountryInfoService
  ) {}

  ngOnInit(): void {
    const meta = this.countryInfo.getMeta(this.currency.code);
    if (!meta) return;

    this.flagPath = meta.flag;

    const hours = Math.abs(meta.gmtOffset).toString().padStart(2, '0');
    const sign  = meta.gmtOffset >= 0 ? '+' : '-';

    this.gmtLabel = `${meta.name} (UTC ${sign}${hours}:00)`;
  }
}
